/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { FETCHING_ANALYTICS, RECEIVE_ANALYTICS, SELECT_EMBED_UUID } from 'state/actions/embedsState/embedAnalytics';
import { formContentsData } from 'state/reducers/embedsState/embedManagementState/contentStatus/content_status_helpers';


/* ========== ~~~~~~~~~~ EMBEDS STATE > EMBEDS STATUS: REDUCER ~~~~~~~~~~ ========== */

// ^-^ ^-^ ^-^ ^-^ ^-^   DEFAULT STATE   ^-^ ^-^ ^-^ ^-^ ^-^ //

const defaultState = {
    selectedEmbedUUID: null,
    selectedEmbedName: null,
    fetchingAnalytics: false,
    contents: {
        contents: {}
    },
    currentPage : 1,
    totalRows : 0,
    totalPages : 0,
    lastUpdatedAt : null
};


// REDUCER
// used to manipulate application state
// takes an action, checks its type, based on that performs certain functionality, then returns new slice of state
// utilized in "_container" components

const embedAnalytics = (state = defaultState, action) => {
    let newState = JSON.parse(JSON.stringify(state));
    switch (action.type) {
        case FETCHING_ANALYTICS:
            newState.fetchingAnalytics = action.status;
            return newState;
        case RECEIVE_ANALYTICS:
            newState.contents = formContentsData(action.data.contents);
            newState.currentPage = action.data.currentPage;
            newState.totalRows = action.data.totalRows;
            newState.totalPages = action.data.totalPages;
            newState.lastUpdatedAt = action.data.lastUpdatedAt;
            return newState;
        case SELECT_EMBED_UUID:
            newState.selectedEmbedUUID = action.embedUUID;
            newState.selectedEmbedName = action.embedName;
            return newState;
        default:
            return state;
    }
};

/* ++++++++++ --------------- CUSTOM METHODS --------------- ++++++++++ */


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default embedAnalytics;